import { queryCommonFlags } from "@/api/constants";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { getJourneyStatuses } from "@/modules/leads/api/index.v2";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

const useEditStatus = () => {
  const { lead } = useContext(LeadPageContext);
  const [editLeadStatusModalOpen, setEditLeadStatusModalOpen] = useState(false);
  const [statusChangeComment, setStatusChangeComment] = useState("");
  const [statusId, setStatusId] = useState(lead?.data?.lead?.status.id || null);
  const [statusName, setStatusName] = useState("");

  const handleChangeStatus = (e: {
    target: {
      value: {
        name: string;
        uid: string | null;
      };
    };
  }) => {
    setStatusId(e.target.value?.uid);
    setStatusName(e.target.value?.name || "");
  };

  const handleChangeStatusComment = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setStatusChangeComment(e.target.value);
  };

  const statuses = useQuery(
    ["getStatuses"],
    () =>
      lead?.data?.lead?.journey_uid
        ? getJourneyStatuses(lead.data.lead.journey_uid)
        : Promise.resolve(null),
    {
      ...queryCommonFlags,
      enabled: !!lead?.data?.lead?.journey_uid,
    }
  );

  useEffect(() => {
    if (editLeadStatusModalOpen === false) {
      setStatusName("");
    }
  }, [editLeadStatusModalOpen]);

  return {
    status: {
      editLeadStatusModalOpen,
      setEditLeadStatusModalOpen,
      handleChangeStatus,
      handleChangeStatusComment,
      statusChangeComment,
      data: statuses?.data,
      state: statusId,
      statusName: statusName,
      value: lead?.data?.lead?.status?.status || "",
    },
  };
};

export default useEditStatus;
